import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeInviteModal, getInviteableProjects } from 'invite/ducks';
import { fetchOpenProjects } from 'invite/ducks';
import InviteModal from 'invite/components/modal';

export function mapStateToProps(state) {
  const { invite: { modal } } = state;
  return {
    ...modal,
    projects: getInviteableProjects(state),
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchProjects: fetchOpenProjects,
    closeInviteModal,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(InviteModal);
